import { render, staticRenderFns } from "./fideicomiso.vue?vue&type=template&id=377ca903&"
import script from "./fideicomiso.vue?vue&type=script&lang=js&"
export * from "./fideicomiso.vue?vue&type=script&lang=js&"
import style0 from "./fideicomiso.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports